/**
 * Downgrades OpenAPI 3.0.4 definitions to 3.0.3 so the api-docs widget
 * can render them. Handles both JSON and YAML-ish text formats.
 */
export function patchOpenApi(definition: string): string {
  // Try JSON first
  try {
    const json = JSON.parse(definition);
    if (json?.openapi === '3.0.4') {
      json.openapi = '3.0.3';
      return JSON.stringify(json, null, 2);
    }
  } catch {
    // Fall back to YAML-ish text
    return definition.replace(/^(\s*openapi\s*:\s*)["']?3\.0\.4(["'\s#]|$)/m, '$13.0.3$2');
  }
  return definition;
}
